import { useSearchParams } from 'react-router-dom';
import RegistroDiario from './RegistroDiario';
import MonitoreoRegistroBiologo from './monitoreo/MonitoreoRegistroBiologo';
import AlimentacionManual from './monitoreo/AlimentacionManual';

export default function Monitoreo() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'rd';

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex-1 overflow-auto bg-gray-100">
        {tab === 'rd' && (
          <RegistroDiario
            readOnly
            camposEditables={['horas_pausa', 'inicio_hora_pausa', 'observaciones']}
          />
        )}
        {tab === 'rb' && <MonitoreoRegistroBiologo />}
        {tab === 'am' && <AlimentacionManual />}
      </div>
    </div>
  );
}